import React from 'react';
import { Box, Paper, Typography, Stack, IconButton,Link,useMediaQuery,useTheme, } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { RecentIndigent, dashboardService } from '../../../services/dashboardService';

const items = new Array(4).fill({
  number: '817349049282',
  name: 'Zaya Nokubonga',
  meter: '07112958439',
});

interface RecentlyAddedProps {
  indigents: RecentIndigent[];
}

const RecentlyAdded: React.FC<RecentlyAddedProps> = ({ indigents }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return(
  <Paper elevation={3} sx={{ p: 3, borderRadius: "12px", mt:4 }}>

    {/* Header */}
    <Box display="flex"  justifyContent="space-between" alignItems="center" mb={2}>
      <Typography fontWeight={600} fontSize="22px" fontFamily="Poppins, sans-serif" color='#132F5F'>Recently Added</Typography>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Link href="/approval" style={{ textDecoration: 'none' }}>
        <Typography variant="body2" color="#203A6B" sx={{ cursor: 'pointer', fontFamily:"Poppins, sans-serif", fontWeight:"500", fontSize:"14px"}}>
          Approvals
        </Typography>
        </Link>
        <ArrowForwardIcon fontSize="small" sx={{color:'#FF544B', cursor:"pointer"}} />
      </Stack>
    </Box>
    <Stack spacing={1} sx={{ maxHeight: "300px", overflowY: 'auto'  }}>
      {(() => {
        const filteredIndigents = indigents
          .filter(item => item.indigent_number && item.name && item.electricity_meter_no && item.id)
          .slice(0, 4);
        
        if (filteredIndigents.length === 0) {
          return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100px">
              <Typography color="text.secondary" fontSize="14px">
                No recent indigents found
              </Typography>
            </Box>
          );
        }
        
        return filteredIndigents.map((item, i) => (
        <Paper
          key={item.id}
          variant="outlined"
          sx={{ p: 1, display: 'flex', flexDirection: 'column', borderRadius: "28px",backgroundColor:"#FAF9F9",borderColor:"#FAF9F9" }}
        >
          <Box
      sx={{
        backgroundColor: '#FAF9F9',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        //alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: 60,
      }}
    >
      {/* Left Icon */}
      <IconButton size="small" sx={{ mr: isMobile ? 0 : 2, ml: isMobile?'auto':0 }}>
        <MoreVertIcon />
      </IconButton>

      {/* Content Grid */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr 1fr',
          gap: isMobile ? 2 : 3,
          flexGrow: 1,
          width: '100%',
          alignItems: 'center'
        }}
      >
        {/* Indigent Number */}
        <Stack spacing={0.5} alignItems={isMobile ? 'flex-start' : 'center'}>
          <Typography
            variant="body2"
            color="#ABABAB"
            fontWeight={400}
            textAlign={isMobile ? 'left' : 'center'}
          >
            Indigent Number:
          </Typography>
          <Stack direction="row" alignItems="center" spacing={0.5} justifyContent={isMobile ? 'flex-start' : 'center'}>
            <OpenInNewIcon sx={{ fontSize: 14, color: '#303031' }} />
            <Link
              href={`/edit/${item.id}`}
              underline="hover"
              color="#2979F1"
              fontWeight={600}
              fontSize={14}
              sx={{ cursor: 'pointer' }}
            >
              {item.indigent_number}
            </Link>
          </Stack>
        </Stack>

        {/* Full Name */}
        <Stack spacing={0.5} alignItems={isMobile ? 'flex-start' : 'center'}>
          <Typography
            variant="body2"
            color="text.secondary"
            fontWeight={500}
            textAlign={isMobile ? 'left' : 'center'}
          >
            Full Name
          </Typography>
          <Typography fontWeight={700} textAlign={isMobile ? 'left' : 'center'}>
            {item.name}
          </Typography>
        </Stack>

        {/* Electricity Meter No */}
        <Stack spacing={0.5} alignItems={isMobile ? 'flex-start' : 'center'}>
          <Typography
            variant="body2"
            color="text.secondary"
            fontWeight={500}
            textAlign={isMobile ? 'left' : 'center'}
          >
            Electricity Meter No
          </Typography>
          <Typography fontWeight={700} textAlign={isMobile ? 'left' : 'center'}>
            {item.electricity_meter_no}
          </Typography>
        </Stack>

        {/* Status */}
        <Stack spacing={0.5} alignItems={isMobile ? 'flex-start' : 'center'}>
          <Typography
            variant="body2"
            color="text.secondary"
            fontWeight={500}
            textAlign={isMobile ? 'left' : 'center'}
          >
            Status
          </Typography>
          <Box
            sx={{
              backgroundColor: dashboardService.getStatusColor(item.status),
              color: '#fff',
              px: 1.5,
              py: 0.5,
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: 500,
              textTransform: 'uppercase',
              textAlign: 'center',
              minWidth: 'fit-content'
            }}
          >
            {dashboardService.formatStatus(item.status)}
          </Box>
        </Stack>
      </Box>
    </Box>

        </Paper>
      ));
      })()}
    </Stack>
  </Paper>
);
};

export default RecentlyAdded;
